import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import {
    createFieldCheckbox, createFieldDate, createFieldInputNumber,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import store from "../../../../../store";

const FeeRateRangeList = defineAsyncComponent(() => import("./FeeRateRangeList"));

export const callRequestDocByGroup = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", key: searchQuery, value: searchQuery });
export const callLookup = ({ searchQuery, group }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group, value: searchQuery });
export const callProductType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PRODUCT_USE", value: searchQuery });
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callCountry = ({ searchQuery }) => store.dispatch("resource/v1/master/country/cacheFindAll", {
    where: [
        { name: "nameEn", type: "String", operator: "like", value: searchQuery },
        { logic: 'OR', name: 'nameEnS', operator: 'like', value: searchQuery },
        { logic: 'OR', name: 'nameTh', operator: 'like', value: searchQuery },
    ],
    sort: [{ name: "nameEnS", type: "ASC" }]
});
export const callUserCeo = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true },
    ];
    if (searchQuery) {
        where.push({ name: "idCard", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                select: ["id", "version", "isActive", "idCard", "fullNameTh", "isCeo", "isTemp"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "fullNameTh", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};
export const callHazObjectCoordinate = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refHazObject.isActive", type: "Boolean", operator: "=", value: true },
    ];
    if (searchQuery) {
        where.push({ name: "refHazObject.nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refHazObject.refSpecies.value", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refCoordinateCustoms.name", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/hazObjectCoordinate/search", {
            criteria: {
                select: ["**", "refHazObject.refSpecies.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "refHazObject.nameTh", type: "ASC" },
                    { name: "refHazObject.refSpecies.seq", type: "ASC" },
                    { name: "refCoordinateCustoms.name", type: "ASC" }
                ]
            }
        })
        .then(page => page.data);
};

export const callHazObject = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
    ];
    if (searchQuery) {
        where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refSpecies.value", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/hazObject/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "nameTh", type: "ASC" },
                    { name: "refSpecies.seq", type: "ASC" },
                ]
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.feeRate.requestDocKey"),
            dataIndex: "refRequestDoc.key",
            align: "center",
            width: 120
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.feeRate.refRequestDoc"),
            dataIndex: "refRequestDoc.value",
            inputProp: () => ({ list: callRequestDocByGroup, optLabel: "value" }),
            align: "left",
            width: 500,
            search: {
                name: "refRequestDoc.id"
            }
        }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestDoc`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.refRequestDoc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestDoc,
                            "onUpdate:value": value => (model.refRequestDoc = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestDocByGroup({ searchQuery }).then(items => items.filter(d=>["02", "03", "04", "05", "08", "09", "10", "11", "18", "19"].includes(d.key))),
                            renderLabel: ({ item }) => <div>{item?.key} {item?.value}</div>
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}dueDateDay`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.dueDateDay"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.dueDateDay,
                            "onUpdate:value": value => (modelRef.dueDateDay = value),
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 }, labelAlign: "left" }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}ranges`,
                            fetchCriteria: data.ranges?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "FeeRateRangeList" } })
                    );
                    return <FeeRateRangeList {...componentProp}></FeeRateRangeList>;
                }
            }
        ]
    });
};

export const createFieldExclude = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isExclude`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 }, colon: false }),
                label: () => i18n.global.t("model.feeRate.isExclude"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isExclude,
                            "onUpdate:checked": checked => (model.isExclude = checked),
                            disabled: viewOnly,
                            text: () => i18n.global.t("model.feeRate.isExclude")
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeStartDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeStartDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.excludeStartDate, "onUpdate:value": value => (model.excludeStartDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeEndDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeEndDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.excludeEndDate, "onUpdate:value": value => (model.excludeEndDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeUsers`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeUsers"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeUsers,
                            "onUpdate:value": value => (model.excludeUsers = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callUserCeo({ searchQuery }).then(items => items.map(item => ({ refUser: item }))),
                            mode: "multiple",
                            optKey: "refUser.id",
                            renderLabel: ({ item }) => (<div>{item?.refUser?.idCard} {item?.refUser?.fullNameTh}</div>)
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refUser?.fullNameTh }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeProducts`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeProducts"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeProducts,
                            "onUpdate:value": value => (model.excludeProducts = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHazObjectCoordinate({ searchQuery }).then(items => items.map(item => ({ refProduct: item }))),
                            mode: "multiple",
                            optKey: "refProduct.id",
                            renderLabel: ({ item }) => {
                                return <span>{item.refProduct?.refHazObject?.nameTh} - {item.refProduct?.refHazObject?.refSpecies?.value} ({item.refProduct?.refCoordinateCustoms?.name})</span>;
                            },
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refProduct?.refHazObject?.nameTh || record.refHazObject?.nameTh }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeNetAmount`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeNetAmount"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.excludeNetAmount,
                            "onUpdate:value": value => (modelRef.excludeNetAmount = value),
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeQty`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeQty"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.excludeQty,
                            "onUpdate:value": value => (modelRef.excludeQty = value),
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <hr></hr>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeOperations`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeOperations"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeOperations,
                            "onUpdate:value": value => (model.excludeOperations = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "USER_OBJECTIVE" }).then(items => items.map(item => ({ key: "Operation", refFeeRateId: model.id, refOperation: item }))),
                            optLabel: "refOperation.value",
                            mode: "multiple",
                            optKey: "refOperation.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refOperation?.value }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeHazSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeHazSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeHazSpecies,
                            "onUpdate:value": value => (model.excludeHazSpecies = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "HAZ_SPECIES" }).then(items => items.map(item => ({ key: "HazSpecies", refFeeRateId: model.id, refOperation: item }))),
                            optLabel: "refOperation.value",
                            mode: "multiple",
                            optKey: "refOperation.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refOperation?.value }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeToUses`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeToUses"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeToUses,
                            "onUpdate:value": value => (model.excludeToUses = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "HAZ_PRODUCT_USE_DISCUSS" }).then(items => items.map(item => ({ key: "ToUse", refFeeRateId: model.id, refOperation: item }))),
                            optLabel: "refOperation.value",
                            mode: "multiple",
                            optKey: "refOperation.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refOperation?.value }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeHazLicenseObjectives`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeHazLicenseObjectives"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeHazLicenseObjectives,
                            "onUpdate:value": value => (model.excludeHazLicenseObjectives = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "HAZ_LICENSE_OBJECTIVE" }).then(items => items.map(item => ({ key: "HazLicenseObjective", refFeeRateId: model.id, refOperation: item }))),
                            optLabel: "refOperation.value",
                            mode: "multiple",
                            optKey: "refOperation.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refOperation?.value }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeTransportObjectives`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeTransportObjectives"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeTransportObjectives,
                            "onUpdate:value": value => (model.excludeTransportObjectives = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "TRANSPORT_OBJECTIVE" }).then(items => items.map(item => ({ key: "TransportObjective", refFeeRateId: model.id, refOperation: item }))),
                            optLabel: "refOperation.value",
                            mode: "multiple",
                            optKey: "refOperation.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refOperation?.value }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <hr></hr>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeCarrySourceCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeCarrySourceCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeCarrySourceCountries,
                            "onUpdate:value": value => (model.excludeCarrySourceCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ group: "CarrySource", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refCountry?.nameTh }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeSourceCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeSourceCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeSourceCountries,
                            "onUpdate:value": value => (model.excludeSourceCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ group: "Source", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refCountry?.nameTh }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeDestinationCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeDestinationCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeDestinationCountries,
                            "onUpdate:value": value => (model.excludeDestinationCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ group: "Destination", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refCountry?.nameTh }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}excludeManufactureCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.feeRate.excludeManufactureCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.excludeManufactureCountries,
                            "onUpdate:value": value => (model.excludeManufactureCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ group: "Manufacture", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refCountry?.nameTh }
            }),
        ]
    });
};